import { render } from "./TotalCallsChart.vue?vue&type=template&id=716ae7f6&ts=true"
import script from "./TotalCallsChart.vue?vue&type=script&lang=ts"
export * from "./TotalCallsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__